import React, { useState } from "react";
import Header from "./components/Header";
import Maintenance from "./components/Maintenance";
import Home from "./components/Home";
//import Info from "./components/Info";
import ProtectedRoute from "./components/Authentication/ProtectedRoute";
import SignIn from "./components/Authentication/Signin";
import ForgotPassword from "./components/Authentication/ForgotPassword";
import ResetPassword from "./components/Authentication/ResetPassword";
import ListDojos from "./components/Reports/ListDojos";
import ListUsers from "./components/Reports/ListUsers";
import ListExams from "./components/Reports/ListExams";
import ListReserves from "./components/Reports/ListReserves";
import ListTeachers from "./components/Reports/ListTeachers";
import ListNafudaKake from "./components/Reports/ListNafudaKake";
import AportesList from "./components/Aportes/AportesList";
import PaymentList from "./components/Payment/PaymentList";
import DojosList from "./components/MyDojos/DojosList";
import DojosClassesList from "./components/MyDojos/DojosClassesList";
import ExaminationList from "./components/ReserveDate/ExaminationList";
import ExaminationDetail from "./components/ReserveDate/ExaminationDetail";
import QualifyDateList from "./components/QualifyDate/QualifyDateList";
import QualifyDateDetail from "./components/QualifyDate/QualifyDateDetail";
import QueryQualifyDateList from "./components/QualifyDate/QueryQualifyDateList";
import QueryQualifyDateDetail from "./components/QualifyDate/QueryQualifyDateDetail";
import ExamineList from "./components/Examination/ExamineList";
import ExaminePrevList from "./components/ExaminationPrev/ExaminePrevList";
import BulkLoadUsers from "./components/BulkLoad/BulkLoadUsers";
import BulkLoadExams from "./components/BulkLoad/BulkLoadExams";
import BulkProcessUserList from "./components/BulkLoad/BulkProcessUsers";
import BulkProcessExamList from "./components/BulkLoad/BulkProcessExams";
import BulkProcessDojoList from "./components/BulkLoad/BulkProcessDojos";
import UpdateAikikai from "./components/BulkLoad/UpdateAikikai";
import UpdatePaid from "./components/BulkLoad/UpdatePaid";
import { Switch, Route } from "react-router-dom";
import "./App.css";

// https://react-bootstrap.github.io/getting-started/introduction

function App() {
  const ls = require("localstorage-ttl");

  const [isMaintenance, setMaintenance] = useState(false);

  const [isLoggedIn, setLoggedIn] = useState(!!ls.get("jwt"));
  const [activeUser, setActiveUser] = useState();

  const queryParams = new URLSearchParams(window.location.search);
  const code = queryParams.get("code");

  if (isMaintenance) {
    return (
      <div className="App">
        <Maintenance />
      </div>
    );
  }

  return (
    <div className="App">
      <Header
        isLoggedIn={isLoggedIn}
        setLoggedIn={setLoggedIn}
        setActiveUser={setActiveUser}
      />
      <Switch>
        <Route path="/" exact>
          <Home isLoggedIn={isLoggedIn} />
        </Route>
        {/* <Route path="/info">
          <Info/>
        </Route> */}
        <ProtectedRoute path="/aportes" level="1" activeUser={activeUser}>
          <AportesList />
        </ProtectedRoute>
        <ProtectedRoute path="/dojosList" level="1" activeUser={activeUser}>
          <DojosList />
        </ProtectedRoute>
        <ProtectedRoute path="/paymentList" level="3" activeUser={activeUser}>
          <PaymentList />
        </ProtectedRoute>

        <ProtectedRoute
          path="/dojos/:id/classes"
          level="1"
          activeUser={activeUser}
        >
          <DojosClassesList />
        </ProtectedRoute>

        <ProtectedRoute
          path="/examinationList"
          level="1"
          activeUser={activeUser}
        >
          <ExaminationList />
        </ProtectedRoute>
        <ProtectedRoute
          path="/examination/:id"
          level="1"
          activeUser={activeUser}
        >
          <ExaminationDetail />
        </ProtectedRoute>
        <ProtectedRoute
          path="/examinePrevList"
          level="1"
          activeUser={activeUser}
        >
          <ExaminePrevList />
        </ProtectedRoute>
        <ProtectedRoute path="/qualifyList" level="2" activeUser={activeUser}>
          <QualifyDateList />
        </ProtectedRoute>
        <ProtectedRoute path="/qualify/:id" level="2" activeUser={activeUser}>
          <QualifyDateDetail />
        </ProtectedRoute>
        <ProtectedRoute
          path="/queryQualifyList"
          level="1"
          activeUser={activeUser}
        >
          <QueryQualifyDateList />
        </ProtectedRoute>
        <ProtectedRoute
          path="/queryQualify/:id"
          level="1"
          activeUser={activeUser}
        >
          <QueryQualifyDateDetail />
        </ProtectedRoute>
        <ProtectedRoute path="/examineList" level="2" activeUser={activeUser}>
          <ExamineList />
        </ProtectedRoute>
        <ProtectedRoute path="/bulkLoadUsers" level="3" activeUser={activeUser}>
          <BulkLoadUsers />
        </ProtectedRoute>
        <ProtectedRoute path="/bulkLoadExams" level="3" activeUser={activeUser}>
          <BulkLoadExams />
        </ProtectedRoute>
        <ProtectedRoute
          path="/bulkProcessUsers"
          level="3"
          activeUser={activeUser}
        >
          <BulkProcessUserList />
        </ProtectedRoute>
        <ProtectedRoute
          path="/bulkProcessExams"
          level="3"
          activeUser={activeUser}
        >
          <BulkProcessExamList />
        </ProtectedRoute>
        <ProtectedRoute
          path="/bulkProcessDojos"
          level="3"
          activeUser={activeUser}
        >
          <BulkProcessDojoList />
        </ProtectedRoute>
        <ProtectedRoute path="/listDojos" level="3" activeUser={activeUser}>
          <ListDojos />
        </ProtectedRoute>
        <ProtectedRoute path="/listUsers" level="3" activeUser={activeUser}>
          <ListUsers />
        </ProtectedRoute>
        <ProtectedRoute path="/listReserves" level="3" activeUser={activeUser}>
          <ListReserves />
        </ProtectedRoute>
        <ProtectedRoute path="/listExams" level="3" activeUser={activeUser}>
          <ListExams />
        </ProtectedRoute>
        <ProtectedRoute path="/listTeachers" level="3" activeUser={activeUser}>
          <ListTeachers />
        </ProtectedRoute>
        <ProtectedRoute
          path="/listNafudaKake"
          level="1"
          activeUser={activeUser}
        >
          <ListNafudaKake />
        </ProtectedRoute>
        <ProtectedRoute path="/updateAikikai" level="3" activeUser={activeUser}>
          <UpdateAikikai />
        </ProtectedRoute>
        <ProtectedRoute path="/updatePaid" level="3" activeUser={activeUser}>
          <UpdatePaid />
        </ProtectedRoute>
        <Route path="/signin">
          <SignIn
            isLoggedIn={isLoggedIn}
            setActiveUser={setActiveUser}
            setLoggedIn={setLoggedIn}
          />
        </Route>
        <Route path="/forgot-password">
          <ForgotPassword />
        </Route>
        <Route path="/reset-password">
          <ResetPassword code={code} />
        </Route>
      </Switch>
    </div>
  );
}

export default App;
